import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap"
import { Component, Input } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { Router } from "@angular/router"
import { StudentLogin } from "../../../models/studentLogin"

@Component({
    selector: "app-student-login-modal",
    templateUrl: "./student-login-modal.component.html",
    styleUrls: ["./student-login-modal.component.less"],
})
export class StudentLoginModalComponent {
    public googleImage: string = null
    public studentUsername: string = null
    public secretAnswer: string = null
    public studentLogin: StudentLogin

    @Input() public nextURL: string = null
    @Input() public overrideStudentNext: boolean = false

    constructor(
        public activeModal: NgbActiveModal,
        public userService: UserService,
        private router: Router
    ) {
        this.studentLogin = new StudentLogin(this.userService, this.router)
        this.googleImage = require("../../../../assets/auth-google.svg")
    }

    public getStudentNext() {
        return this.overrideStudentNext
            ? this.nextURL
            : this.studentLogin.getCurrentStudentPath()
    }
}
